export function encodeBase64(value: string) {
  if (import.meta.server) {
    return Buffer.from(value, 'utf8').toString('base64');
  } else {
    return btoa(value);
  }
}
